<template>
  <Card class="ship-order-loading-card">
    <template #content>
      <div class="flex flex-column">
        <div class="top-row flex flex-gap-1">
          <Skeleton width="25%" height="1.5rem" class="bg-gray-darker" />
          <Skeleton width="15%" height="1rem" class="bg-gray-dark" />
          <Skeleton width="15%" height="1rem" class="bg-gray-dark" />
        </div>

        <div
          class="second-row flex flex-gap-1 justify-content-between align-items-center bg-gray"
        >
          <Skeleton width="30%" height="1.5rem" class="bg-gray-dark" />
          <FontAwesomeIcon
            aria-hidden="true"
            class="text-gray-darker"
            :icon="['fal', 'long-arrow-right']"
          />
          <Skeleton width="30%" height="1.5rem" class="bg-gray-dark" />
        </div>
      </div>
    </template>
  </Card>
</template>

<script lang="ts" setup>
import Card from 'primevue/card';
import Skeleton from 'primevue/skeleton';
</script>

<style>
.ship-order-loading-card.p-card {
  border: 1px solid var(--p-gray-200);

  .p-card-body {
    padding: 0;

    .top-row {
      padding: var(--sp-3);
    }

    .second-row {
      padding: var(--sp-3);

      .pi.pi-arrow-right {
        transform: scaleX(150%);
      }
    }
  }
}
</style>
